declare var x_textos: any;
import CryptoJS from 'crypto-js';
import LZString from 'lz-string';
import { iUtilsTM } from './tagManager';
import { Loader } from '@googlemaps/js-api-loader';

export class Utils implements iUtilsTM {

    findText(pal: any) {
        let self = this;
        if (pal == null) return '';
        var txtreturn = ''
        if (typeof pal == 'object') {
            $.each(pal, function (index, data) {
                var pre_txtreturn = ''
                    , t_data = ''
                    , isObject = typeof data == 'object' && data !== null
                    , isFormat = false
                if (isObject) {
                    t_data = data.text
                    isFormat = data.format == true
                }
                else {
                    t_data = data
                }

                if (isObject && !isFormat) {
                    pre_txtreturn = JSON.stringify(t_data)
                }
                else if (typeof t_data == 'object') {
                    pre_txtreturn = pre_txtreturn + ' ' + self.findText(t_data)
                }
                else if (String(t_data).substr(0, 4) == 'txt-') {
                    pre_txtreturn = pre_txtreturn + ' ' + self.getWord(t_data)
                }
                else if (t_data == '||') {
                    pre_txtreturn = pre_txtreturn + '<br />';
                }
                else {
                    pre_txtreturn = pre_txtreturn + ' ' + t_data
                }

                if (isFormat) {
                    txtreturn += '<span style="' + data.css + '">' + pre_txtreturn + '</span>'
                }
                else {
                    txtreturn += pre_txtreturn
                }
            })
        }
        else {
            if (String(pal).substr(0, 4) == 'txt-') {
                txtreturn = this.getWord(pal)
            }
            else {
                txtreturn = pal
            }
        }

        if (typeof txtreturn == 'string') {
            txtreturn = txtreturn.trim()
        }
        return txtreturn
    };


    getWord(key: any) {
        if (String(key).substr(0, 4) == 'txt-') {
            key = String(key).substr(4)
        }
        if (typeof x_textos === 'undefined') return '';
        if (typeof x_textos[key] === 'undefined') return '';
        return (x_textos[key]);
    };

    construirDataForm($form: any) {
        let tipo_pago = $('[name="tipo_pago"]').val(),
            inputs = null,
            elem_name = null,
            args = []

        if (tipo_pago === 'credito') {
            elem_name = 'titular_credito'
            inputs = ['ctipodc', 'cdocuc', 'cnombrec', 'capellidoc', 'cemailc', 'cciudadc', 'ccelularc']

        }
        else if (tipo_pago === 'debito') {
            elem_name = 'titular_debito'
            inputs = ['ctipod', 'cdocud', 'cnombred', 'capellidod', 'cemaild', 'cciudadd', 'ccelulard']
        }
        else {
            return $form.serializeArray();
        }

        if ($('input[name="' + elem_name + '"]:checked').val() !== 'si') {
            return $form.serializeArray();
        }

        let args_array = $form.serializeArray(),
            num_args = args_array.length

        for (let i = 0; i < num_args; i++) {
            let arg = args_array[i]
                , name_obj = arg['name']
                , val = null

            switch (name_obj) {
                case inputs[0]:
                    val = $('#tdoc').val()
                    break

                case inputs[1]:
                    val = $('#ndoc').val()
                    break

                case inputs[2]:
                    val = $('#name').val()
                    break

                case inputs[3]:
                    val = $('#lastname').val()
                    break

                case inputs[4]:
                    val = $('#email').val()
                    break

                case inputs[5]:
                    val = $('#ciudad').val()
                    break

                case inputs[6]:
                    val = $('#tel2').val()
                    break

                default:
                    val = arg['value']
            }
            args.push({ name: arg.name, value: val })
        }
        return args;
    }

    serializarData(dataForm: any, $frut: any = undefined, $fcc: any = undefined) {
        let formData = new FormData();
        for (let k in dataForm) {
            formData.append(dataForm[k].name, dataForm[k].value)
        }

        if ($frut && $frut.length != 0) {
            formData.append('frut', $frut.get(0).files[0]);
        }

        if ($fcc && $fcc.length != 0) {
            formData.append('fcc', $fcc.get(0).files[0]);
        }

        formData.append('csrf_token', this.getCsrfToken());  // Agrega el token CSRF a los datos


        return formData
    }

    getPriceAjax(formData: any, callback_success: any, callback_error: any) {

        $.ajax({
            url: '/action/get-price/',
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            dataType: 'json',
            success: function (data) {
                callback_success(data);
            },
            error: function (xhr, status) {
                callback_error(xhr, status);
            }
        });
    }

    sendMsjModal(msj: string, title: string, auto_close = true, text_btn?: string | false, callback_confirmacion?: () => void, time = 3000, cargando = false, btn_close = false, bg_title = "bg-primary") {

        let modal = $('#modal');
        var modalDialog = $("#modal .modal-dialog");

        $(modal).addClass("modal-100");

        modal.modal({
            backdrop: 'static',
        }).modal('show');

        let color_text_title = 'text-white'
        switch (bg_title) {
            case "bg-warning":
                color_text_title = 'text-primary'
                break;
            default:
                break;
        }

        let title_html = '<div class="title-modal text-center ' + bg_title + ' ' + color_text_title + ' fs-5 p-2">'
            + title +
            (btn_close ? `<button id="modal-close" class="btn text-white  modal-close float-end">
                                <i class="alk alk-close"></i>
                            </button></div>` : '</div>');

        let html_btn = text_btn ? '<button id="btn-confirmacion" class="btn btn-success uppercase m-3" >' + text_btn + '</button>' : '';
        let html = (title ? title_html : '') + '<p class="mensaje text-center m-3">' + msj + '</p> ' + (cargando ? '<div class="text-center p-3"><div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading...</span></div></div>' : '') + ' ' + html_btn;

        modalDialog.html(html);
        if (auto_close) setTimeout(() => { this.closeMsjModal(); }, time);

        callback_confirmacion = callback_confirmacion || (() => { this.closeMsjModal(); });

        $("#btn-confirmacion").on('click', function () {
            if (typeof callback_confirmacion === 'function') {
                callback_confirmacion();
            }
        });
    }

    goTo(url: string) {
        if (alk_lang != 'es') {
            window.location.href = '/' + alk_lang + url;
        } else {
            window.location.href = url;
        }
    }

    closeMsjModal() {
        $("#modal").modal("hide");
        $("#modal-forgot").modal("hide");
        $('#modal-registrate').modal('hide');
        $('#modal-login').modal('hide');
    }

    temporizadorPagV2(callback: any, callbackTime: any = false) {
        let $timeVar: any = $('[data-time]');
        let time: any = $timeVar.attr('data-time');
        let expr_time: any = (time ? parseInt(time) : 1200) * 1000;
        let timeEnd: any = new Date(Date.now() + expr_time);


        let genera_timer = setInterval(function () {
            let ahora: any = new Date();
            let mil_sec: any = timeEnd - ahora;
            if (mil_sec <= 0) {
                clearInterval(genera_timer);
                callback();
            } else {
                if (callbackTime) callbackTime(mil_sec);
            }
        }, 1000);

        return genera_timer;
    }

    sendIALQ(dataForm: any, tiempo: any) {
        if (tiempo === 0) {
            $.ajax({ url: '/action/ialq/', type: 'POST', data: dataForm });
            return false
        }
        else {
            return setTimeout(function () {
                $.ajax({ url: '/action/ialq/', type: 'POST', data: dataForm });
            }, tiempo);
        }
    }


    printButtons(btn: any) {
        let print = '';
        for (let i in btn) {
            let url = '';

            switch (alk_lang) {
                case 'es':
                    url = btn[i].intLink;
                    break;
                default:
                    url = '/' + alk_lang + btn[i].intLink;
                    break;
            }

            // let action = btn[i].action == undefined ? 'confirm' : btn[i].action
            print = print + '<a class="btn btn-success uppercase m-3" href="' + url + '">' + this.findText(btn[i].title) + '</a> &nbsp'
        }
        return print
    }

    createCookie(name: any, value: any, days: any, domain: any) {
        var expires = '';
        if (days !== null) {
            var date = new Date(), today = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = ";time = " + today + "; expires=" + date.toUTCString();
        }
        if (domain != 'localhost' && domain.match(/[a-z]/i) != null) { domain = '.' + domain; }
        document.cookie = name + "=" + value + expires + "; path=/;domain=" + domain + '; SameSite=None; SameSite=Lax; Secure'
    }

    createCookieSeconds(name: any, value: any, seconds: any, domain: any) {
        var expires = '';
        if (seconds !== null) {
            var date = new Date();
            date.setTime(date.getTime() + (seconds * 1000)); // Convert seconds to milliseconds
            expires = "; expires=" + date.toUTCString();
        }
        if (domain != 'localhost' && domain.match(/[a-z]/i) != null) {
            domain = '.' + domain;
        }
        document.cookie = name + "=" + value + expires + "; path=/; domain=" + domain + '; SameSite=None; SameSite=Lax; Secure';
    }

    eraseCookie(name: any, domain: any) {
        this.createCookie(name, '', -1, domain);
    }

    readCookie(name: any) {
        var nameEQ = name + "=", ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    jSONInfo(config: any, option: any, callBack: any) {
        option['csrf_token'] = this.getCsrfToken();  // Agrega el token CSRF a los datos
        let cnfAjax: any = {
            url: config.dir
            , type: config.type
            , data: option
            , dataType: "json"
            , success: function (data: any) {
                if (typeof callBack == 'function') callBack(data);
            }
            , error: function (data: any, status: any, e: any) {
                console.error("jSONInfo - No se pudo cargar la pagina: ", data.responseText);
            }
        };
        let $files = config.Files;
        if ($files != undefined && $files.length != 0) {
            cnfAjax.fileElementId = $files;
            (jQuery as any).ajaxFileUpload(cnfAjax);
        }
        else {
            $.ajax(cnfAjax);
        }
    }

    afterSubmit(data: any, id_form: any, cerrar: any) {
        let status = data.status;
        if (!status.error) {
            let e: any = $('#' + id_form)[0];
            e.reset()
        }
        this.printMessages(data, id_form, cerrar);
    }


    printMessages(data: any, id_form: any, cerrar: any) {
        const $form = $('#' + id_form),
            $ctm_msg = $form.find('.ctm_msg'),
            status = data.status

        if ($ctm_msg.is(':visible')) $ctm_msg.slideUp('fast')

        $ctm_msg.text(this.findText(data.mensaje))
        $ctm_msg.removeClass('alert alert-danger alert-success')
            .addClass(data.status.error ? 'alert alert-danger' : 'alert alert-success')

        $ctm_msg.slideDown('fast');
        setTimeout(() => {
            $ctm_msg.slideUp('fast');

            if (status.close && typeof cerrar == 'function') {
                cerrar()
            }

            if (status.reload) {
                window.location.reload()
            }

            if (status.go) {
                window.location.href = status.go
            }

            if (status.go_to) {
                window.location.href = status.go_to
            }

        }, status.error ? 9000 : 2000)
    }

    validateUser($email: any) {
        /*
        $('#modal-validate').modal({ dismissible: false});
        $('#modal-validate').modal('open');
        $('#form-reg-usuario')[0].reset();
        $('#modal-registrate').modal('close');
    
        */

        $('#modal-validate').modal().modal('show');

        let self = this;

        $("#form-validate").attr('action', '/action/validate-user/');
        $('#object').val($email);

        $('#form-validate').off('submit');

        $('#form-validate').on('submit', function (e) {
            e.preventDefault();
            e.stopPropagation();

            let form_validate: any = $(this);
            let attr = form_validate.serializeObject();

            // Convertir el objeto en un objeto clave-valor
            var formObject: any = {};
            $.each(attr, function (index, field) {
                formObject[field.name] = field.value;
            });

            let config = { dir: form_validate.attr('action'), type: form_validate.attr('method') };

            self.jSONInfo(config, formObject, function (data: any) {
                self.afterSubmit(data, 'form-validate', function () {
                    self.closeMsjModal();
                    setTimeout(function () {
                        ///$('#modal-login').modal('open');
                        $("#btn-login-modal").click(function (event) {
                            event.preventDefault();
                            $("#form-login-modal").submit();
                        });
                    }, 1000);
                });
            });

            return false;

        });
    }

    getUserinfo() {
        if (window.localStorage) {
            if (window.localStorage.getItem('_user') == null) {
                return { status: false }
            }
            else {

                try {
                    let u = window.localStorage.getItem('_user');
                    let _user = u ? JSON.parse(u) : []
                    _user.status = true
                    return _user
                } catch (error) {

                }

            }
        }
        return { status: false }
    }

    setLocalStorage(key: string, val: string) {
        let s = CryptoJS.AES.encrypt(val, "aksdjashdkjss");
        localStorage.setItem(key, s.toString())
    }

    getLocalStorage(key: any) {
        let v = localStorage.getItem(key);
        // return localStorage.getItem(key);

        if (v) {
            return CryptoJS.AES.decrypt(v, "aksdjashdkjss").toString(CryptoJS.enc.Utf8);
        } else {
            return null;
        }
    }

    decryptAES(value: string, key: string) {
        return CryptoJS.AES.decrypt(value, key).toString(CryptoJS.enc.Utf8);
    }

    encryptAES(value: string, key: string) {
        return CryptoJS.AES.encrypt(value, key).toString();
    }

    getSha1(text: string): string {
        return CryptoJS.SHA1(text).toString(CryptoJS.enc.Hex);
    }

    compressEncodedURI(data: string): string {
        return LZString.compressToEncodedURIComponent(data);
    }

    decompressEncodedURI(compressedData: string): string {
        return LZString.decompressFromEncodedURIComponent(compressedData);
    }

    getFormData(dataForm: any, $filesArray: any = []) {
        let formData = new FormData();
        for (let k in dataForm) {
            formData.append(dataForm[k].name, dataForm[k].value);
        }

        $filesArray.forEach(($file: any) => {
            formData.append($file.attr('name'), $file.get(0).files[0]);
        });

        formData.append('csrf_token', this.getCsrfToken());  // Agrega el token CSRF a los datos

        return formData
    }

    initAutoCiudad($input: JQuery<HTMLInputElement>,
        componentForm: { field: string, input: JQuery<HTMLInputElement>, type: 'long_name' | 'short_name' }[],
        zipCodeInput?: JQuery<HTMLInputElement>) {
        if ($input.length == 0) return;

        const loader = new Loader({
            apiKey: "AIzaSyBX3sk5jCiaS1NpTKb27Rx0k5Si06s2lR0",
            version: "weekly"
        });

        loader.importLibrary('places').then(() => {
            let placeholder = $input.attr('placeholder')
                , attr_autocomplete = $input.attr('autocomplete')
                , type = attr_autocomplete == 'shipping locality' ? ['(cities)'] : ['address']
                , autocomplete = new google.maps.places.Autocomplete($input[0], { types: type });

            $input.attr({ placeholder: placeholder, autocomplete: attr_autocomplete });
            autocomplete.addListener('place_changed', function () {
                let place = autocomplete.getPlace();

                try {
                    const postalCode = place?.address_components?.find((component: any) => component.types.includes('postal_code'))?.long_name;
                    zipCodeInput?.val(postalCode || '');
                } catch (error) { }

                if (componentForm == undefined || componentForm.length == 0) return;
                for (let k in componentForm) {
                    if (place.address_components == undefined) return false;
                    for (let y in place.address_components) {
                        if (place.address_components[y].types.includes(componentForm[k].field)) {
                            componentForm[k].input.val(place.address_components[y][componentForm[k].type] || '');
                            break;
                        }
                    }
                };
            });
        });
    }

    /*statusGoogle() {
        if (typeof google !== "undefined") {
            return true;
        }
        else {
            setTimeout(this.statusGoogle, 50);
        }
    }

    iniciarAutocompleteGoogle(id_input: any, calculos: any = {}) {
        let self = this;
        var $input = $('#' + id_input)
        if ($input.length == 0) return false;
        let autocomplete = new google.maps.places.Autocomplete($input[0], { types: ['address'] })
            , setDirection = function (direction: any, id_input: any, $input: any) {
                self.getGeodecoder(direction, function (status: any, lat: any, lng: any, placeName: any) {
                    $input.removeAttr('disabled')
                    if (status) {
                        $input.val(placeName);
                        self.getLatLng($input, id_input, lat, lng, calculos)
                    }
                    else {
                        $input.val('');
                        self.setErrorAutocomplete($input)
                    }
                    $input.attr('data-status', 'check')
                })
            }
        autocomplete.addListener('place_changed', function () {
            let place = autocomplete.getPlace()
                , lat = 0
                , lng = 0
            if (place.geometry != undefined) {
                lat = place.geometry.location.lat()
                lng = place.geometry.location.lng()
                if (calculos != undefined) self.getLatLng($input, id_input, lat, lng, calculos)
                $input.attr('data-status', 'check')
            }
            else {
                let direction: any = $('.pac-container:visible .pac-item').first().text();
                if (direction == "") direction = $input.val()
                $input.attr('disabled', 'disabled')
                setDirection(direction, id_input, $input)
            }
        })

        $input.keypress(function (e) {
            if (e.which != 13) {
                $input.removeAttr('data-status')
            }
        })
        $input.blur(function (e) {
            setTimeout(function () {
                let status = $input.attr('data-status') == 'check'
                    , cambio = !status && $input.val() != ''

                if (!status && !cambio) {
                    self.setErrorAutocomplete($input)
                }
                else if (cambio) {
                    setDirection($input.val(), id_input, $input)
                }
            }, 80)
        })
    }*/

    getGeodecoder(dir_to_geo: any, callback: any) {
        let geocoder = new google.maps.Geocoder()
        geocoder.geocode({ "address": dir_to_geo }, function (results: any, status: any) {
            if (status == google.maps.GeocoderStatus.OK) {
                var lat = results[0].geometry.location.lat(),
                    lng = results[0].geometry.location.lng(),
                    placeName = results[0].formatted_address;

                if (callback != undefined) {
                    callback(true, lat, lng, placeName)
                }

            }
            else {
                if (callback != undefined) {
                    callback(false)
                }
            }
        });
    }


    getLatLng($input: any, id_input: any, lat: any, lng: any, calculos: any) {
        let $error = $input.parents('.datos-domicilio').find('.error')

        if ($error.length) {
            $error.remove()
            $input.removeClass('invalid')
        }

        let recogida = id_input === 'dir-origen' ? 1 : 0,
            entrega = id_input === 'dir-recogida' ? 1 : 0,
            cod_search = $('#cod-search').val()

        if (recogida || entrega) {
            let opts = {
                cod: cod_search,
                recogida: recogida,
                entrega: entrega,
                latDomi: lat,
                lngDomi: lng,
                dirDomi: $input.val()
            }
            $input.attr({ 'data-lat': lat, 'data-lng': lng })
            this.jSONInfo({ dir: '/action/getDelivery/', type: 'POST' }, opts, function (data: any) {
                let $reserva = $('#reserva')
                    , ans = data.ans
                    , dataName = recogida ? 'cost_min_domi_i' : (entrega ? 'cost_min_domi_f' : '')
                    , costo = ans.costo

                if (ans.status) {
                    $reserva.attr('data-' + dataName, costo)
                    //calculos.showAllData()  
                } else {
                    $input.parent().append('<span class="error">' + ans.err + '</span>')
                    $input.addClass('invalid')
                }
            })
        }
    }

    setErrorAutocomplete($input: any) {
        let $error = $input.parents('.datos-domicilio').find('.error')
        if ($error.length) {
            $error.remove()
            $input.removeClass('invalid')
        }
        $input.parent().append('<span class="error">' + x_textos["570-0"] + '</span>')
        $input.addClass('invalid')
    }

    getClone(obj: any): any {

        let copy;

        // Handle the 3 simple types, and null or undefined
        if (null == obj || "object" != typeof obj) return obj;

        // Handle Date
        if (obj instanceof Date) {
            copy = new Date();
            copy.setTime(obj.getTime());
            return copy;
        }

        // Handle Array
        if (obj instanceof Array) {
            copy = [];
            for (var i = 0, len = obj.length; i < len; i++) {
                copy[i] = this.getClone(obj[i]);
            }
            return copy;
        }

        // Handle Object
        if (obj instanceof Object) {
            copy = Object.create(obj);
            for (var attr in obj) {
                if (obj.hasOwnProperty(attr)) copy[attr] = this.getClone(obj[attr]);
            }
            return copy;
        }

        throw new Error("Unable to copy obj! Its type isn't supported.");
    }

    setInputValue(element: JQuery, value: any): void {
        if (element.is('input[type="checkbox"]')) {
            if (!Array.isArray(value)) return;
            $(`input[name="${element.attr('name')}"]`).each(function () {
                if (value.includes($(this).val())) {
                    $(this).prop('checked', true).trigger('change');
                }
            });
        } else if (element.is('input[type="radio"]')) {
            $(`input[name="${element.attr('name')}"][value="${value}"]`).prop('checked', true).trigger('change');
        } else if (!element.is('input[type="file"]')) {
            element.val(value).trigger('change');;
        }
    }

    getInputValue(element: JQuery): any {
        if (element.is('input[type="checkbox"]')) {
            let checkedValues: any = [];
            $(`input[name="${element.attr('name')}"]:checked`).each(function () {
                checkedValues.push($(this).val());
            });
            return checkedValues;
        }
        if (element.is('input[type="radio"]')) {
            return $(`input[name="${element.attr('name')}"]:checked`).val();
        }
        if (!element.is('input[type="file"]'))
            return element.val();
    }

    getDateActualToString(seconds_future: any = null) {
        // Obtiene la fecha y hora actual
        const now = new Date();

        // Agrega 120 segundos (convertidos a milisegundos) a la fecha actual
        const futureDate = new Date(now.getTime() + (seconds_future ? seconds_future : 0) * 1000);

        // Formatea la fecha y hora en un string en el formato deseado
        const formattedDateTime = `${futureDate.getFullYear()}-${(futureDate.getMonth() + 1).toString().padStart(2, '0')}-${futureDate.getDate().toString().padStart(2, '0')} ${futureDate.getHours().toString().padStart(2, '0')}:${futureDate.getMinutes().toString().padStart(2, '0')}:${futureDate.getSeconds().toString().padStart(2, '0')}`;

        return formattedDateTime;
    }

    getCsrfToken() {
        let token = $('meta[name="csrf-token"]').attr('content');
        return token ? token : '';
    }

    sprint_f(format: string, ...args: string[]): string {
        return format.replace(/{(\d+)}/g, (match, index) => {
            return typeof args[index] !== 'undefined' ? args[index] : match;
        });
    }
}